type EnvironmentShape = {
  authKey: string
  localeKey: string
}

export const config: EnvironmentShape = {
  authKey: 'AUTH_KEY',
  localeKey: 'LOCALE_KEY',
}
